import { render } from "./CampaignsTable.vue?vue&type=template&id=1bf84da6"
import script from "./CampaignsTable.vue?vue&type=script&lang=js"
export * from "./CampaignsTable.vue?vue&type=script&lang=js"

import "./CampaignsTable.vue?vue&type=style&index=0&id=1bf84da6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__